// Tipos para el viaje
export interface TripData {
  id?: number;
  date?: string;
  shift?: string | null;
  svc?: { id?: number | null; name?: string | null; code?: string | null } | null;
  routeId?: string;
  attended?: boolean;
  routeCompleted?: boolean;
  comment?: string | null;
  discounts?: number;
  status?: string;
}

// Perfil propio del chofer (devuelto por GET /me/profile)
export interface DriverProfile {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  dni: string;
  phone: string | null;
}

// Tipos para la disponibilidad
export interface AvailabilityData {
  availableNextDay: boolean;
  availabilityZone: string;
  driverId: string;
  date: string;
}

// Parada de una ruta
export interface Stop {
  id: number;
  shipmentId: number | null;
  stopNumber: number;
  routeSubId: string | null;
  type: string | null;
  sellerId: string | null;
  name: string | null;
  address: string | null;
  number: string | null;
  neighborhood: string | null;
  city: string | null;
  province: string | null;
  postalCode: string | null;
  startTime: string | null;
  endTime: string | null;
  additionalInfo: string | null;
  svcId: number | null;
}

// Info resumida de un shipment (usado en Dashboard y DriverContext)
export interface ShipmentInfo {
  id: string;
  date: string;
  svc: string;
  /** Id del SVC; null si la respuesta no lo trae (cache vieja). */
  svcId: number | null;
  /** Operación del SVC; null si la respuesta no lo trae. */
  operationId: number | null;
  shift: string;
  time: string;
  address: string;
  status: string;
  stops: Stop[] | null;
  /** Identificador de ruta (ej: "1234"); null si no vino en la respuesta. */
  routeId: string | null;
  /** Sub-ruta de doble ciclo (ej: "A", "B"); null si no vino en la respuesta. */
  routeSubId: string | null;
}

// Enums para zonas y turnos
export enum SVC {
  SVC01 = 'SVC-01',
  SVC02 = 'SVC-02',
  SVC03 = 'SVC-03',
  SVC04 = 'SVC-04',
  SVC05 = 'SVC-05',
  SBU1 = 'SBU-01',
  SBU2 = 'SBU-02',
  SBU3 = 'SBU-03',
  MDQ1 = 'MDQ-01',
}

export enum Shift {
  AM = 'AM',
  PM = 'PM',
}

/** Etiqueta en español para mostrar en UI. Evita que traductores (ej. Google) traduzcan "AM" como "SOY". */
export function getShiftDisplayLabel(shift: string): string {
  switch (shift) {
    case Shift.AM:
      return 'Mañana';
    case Shift.PM:
      return 'Tarde';
    default:
      return shift;
  }
}

// Tipos para vehículos
export interface UnitType {
  id: number;
  name: string;
}

export interface FleetOwner {
  id: number;
  name: string;
  dni: string;
}

export interface Operation {
  id: number;
  name: string;
}

export interface Vehicle {
  id: number;
  plate: string;
  brand: string;
  model: string;
  year: number;
  ownerType: 'INDIVIDUAL' | 'FLEET';
  fleetOwnerId: number | null;
  individualOwnerName: string | null;
  individualOwnerDNI: string | null;
  status: 'ACTIVO' | 'INACTIVO' | 'MANTENIMIENTO';
  unitType: UnitType;
  fleetOwner: FleetOwner | null;
  operation: Operation;
}

export interface VehicleResponse {
  status: number;
  data: Vehicle[];
}

// === Coordinaciones (GET /me/coordinations) ===

export interface MyCoordinationDriver {
  id: string;
  firstName: string;
  lastName: string;
  phone: string | null;
}

export interface MyCoordinationShipment {
  id: number;
  driver: MyCoordinationDriver | null;
  vehiclePlate: string | null;
  time: string | null;
  shift: string | null;
  status: string;
  /** Tipo de unidad del vehículo; null si no matcheó (puede faltar en cache viejo) */
  unitTypeName: string | null;
  /** Código de ruta (ej: ARXCF1_NOR_338_C1); puede faltar en cache viejo */
  structureCode: string | null;
  /** Nombre de la condición de la ruta; puede faltar en cache viejo */
  conditionName?: string | null;
}

/** Chofer del SVC con availability favorita viva (= todavía no citado) */
export interface MyCoordinationUncalledDriver {
  id: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  /** Turno declarado en la availability; null = sin turno */
  shift: string | null;
}

export interface MyCoordinationSvcGroup {
  svc: { id: number; code: string; name: string };
  shipments: MyCoordinationShipment[];
  /** Puede faltar en cache viejo */
  uncalled?: MyCoordinationUncalledDriver[];
}
